// ----------------------------------------------------------------------
// <copyright file="Izenda.MappingHeader.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = require('react');
  var PropTypes = React.PropTypes;

  var EventUtils = require('EventUtils');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var Button = require('share/components/controls/Izenda.Button');
  var Input = require('share/components/controls/Izenda.Input');
  var Label = require('share/components/controls/Izenda.Label');

  var constants = require('logic/data/Izenda.CopyManagementConstants');
  var observer = require('mobx-react').observer;

  /*
  * Header Component
  */
  var MappingHeader = React.createClass({
    propTypes: {
      item : PropTypes.object.isRequired,
      addMapping : PropTypes.func.isRequired,
      localization: PropTypes.object.isRequired,
      tenantMode : PropTypes.bool,
    },
    getDefaultProps : function () {
      return {
        tenantMode: false
      };
    },
    render: function () {
      var props = this.props;
      var localization = props.localization;
      var item = props.item;
      var addMapping = props.addMapping;
      var headerText = props.tenantMode
                       ? constants.MAPPING_HEADER.TENANT
                       : constants.MAPPING_HEADER.GLOBAL;

      var mappingTooltip = props.tenantMode
                        ? constants.MAPPING_HEADER.SPECIFIC_MAPPING_TOOLTIP
                        : constants.MAPPING_HEADER.ALL_MAPPING_TOOLTIP;
      return (
        <GridLayout>

          <GridLayout.Row className='u_table u_fullWidth'>

            <GridLayout.Col
              cols={2}
              className='u_tableCell u_alignMiddle text-bold u_floatNone'>
              {headerText}
              <span className='icon-info-circled' title={mappingTooltip}></span>
            </GridLayout.Col>

            {!props.tenantMode && <GridLayout.Col
              cols={3}
              className='u_tableCell u_alignMiddle u_floatNone'>

              <Input
                type="checkbox"
                checked={item.mergeDuplicateMappings}
                id='mergeDuplicate'
                onChange={EventUtils.notifyChange(this.onMergeDuplicateChanged, EventUtils.CHECKBOX) } />

              <Label
                className='u_paddingRight u_alignMiddle u_textNormal'
                htmlFor='mergeDuplicate'>
                {localization.getText("COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_MERGE_DUPLICATE_MAPPINGS")}
                <span className='icon-info-circled' title={constants.MAPPING_HEADER.MERGE_DUPLICATE_TOOLTIP}></span>
              </Label>

            </GridLayout.Col>}

            <GridLayout.Col
              cols={7}
              className='u_tableCell u_alignMiddle pull-right text-right'>

              <Button
                label={localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_ADD_MAPPING')}
                onClick={addMapping}>
              </Button>

            </GridLayout.Col>

          </GridLayout.Row>

        </GridLayout>
      );
    },

    onMergeDuplicateChanged: function (newValue) {
      var workspace = this.props.item;
      workspace.setPropertyValue('mergeDuplicateMappings', newValue);
    },
  });

  module.exports = observer(MappingHeader);
} ();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/CopyManagement/WorkspaceDetail/Mapping/Izenda.MappingHeader.jsx